import { Model } from "vue-mc";

export class PerfilUsuario extends Model {
  defaults() {
    return {
      username: ""
      , foto: ""
      , fotoMiniatura: ""
    };
  }

  mutations() {
    return {
      username: (username) => username
      , foto: (foto) => foto
      , fotoMiniatura: (fotoMiniatura) => fotoMiniatura
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/seguridad/perfilUsuario.js